(function(){

    'use strict';
angular.module('cvsApp')
    .factory('webAnalytics', ['$rootScope', '$timeout', 'help', 'webAnalyticsData','cvsAppData', function ($rootScope, $timeout, help, webAnalyticsData, CAD) {
        var url = '';
        var deviceType = help.getUserAgent(navigator.userAgent),
            channelName = cvsUtility.queryMap.channel,
            appName = cvsUtility.queryMap.appName ? cvsUtility.queryMap.appName : "SPL_WEB",
            lineOfBusiness = 'Specialty',
            tokenId = cvsUtility.queryMap.tokenId,
            fromQuickRegistration = cvsUtility.queryMap.FromQuickRegistration,
            activePresence = {};

        var webAnalytics = {
            webTrendsUtag: function (data, utagObj, from, scenario) {
                if (from !== 'widget') {
                    utagObj.environment = cvsUtility.utagUrl(true);
                    utagObj.site_name = "cvscaremarkspecialty.com";
                    utagObj.country = "US";
                    utagObj.language = "EN";
                    utagObj.currency = "USD";
                    utagObj.state_logged_in = cvsUtility.queryMap.tokenId ? true : false;
                    utagObj.Registration_Method = this.getActivePresence()=="ACTIVE"?"Registered User":"";
                    /*if (cvsUtility.isMobile()) {
                        utagObj.platform = "tablet";
                    } else {
                        utagObj.platform = "desktop";
                    }*/
                    utagObj.platform = cvsUtility.getPlatform();
                    utagObj.registration_state = cvsUtility.getMemberstatus();
                    if(cvsUtility.getPatientId()!=''){
                        utagObj.patient_id = cvsUtility.getPatientId();
                    }
                    if(!CAD.isGuestRefill() && cvsUtility.queryMap.tokenId){
                        utagObj.log_in_method = "Standard SignIn";
                    }
                    var object = angular.merge({},webAnalyticsData[scenario],utagObj);
                    utagObj = object;
                }
                /**
                 * SP 02/23/2017 - IM5564982
                 * Added condition to verify and remove success status code from page error.
                 */
                if(utagObj.hasOwnProperty('page_error') && utagObj.page_error && (utagObj.page_error.indexOf('0000') > -1 || utagObj.page_error == '')){
                    delete utagObj.page_error;
                }
                else{
                    // console.log('Page Error -->'+utagObj.page_error);
                }
                var utagType = (typeof utag == 'undefined') ? false : true;
                if (utagType) {
                    if (data == "OBJ") {
                        utag.view(utagObj);
                    } else if (data == "LINK") {
                        if(webAnalyticsData[scenario] == !'undefined'){
                        utag.link(webAnalyticsData[scenario]);
                        }else{
                            utag.link(utagObj);
                        }
                    }
                    else if (data == "VIEW") {
                        //utag.view(getScenarioTag(scenario));
                        utag.view(webAnalyticsData[scenario]);
                    }

                }

            },
            setActivePresence: function (data) {
                activePresence = data;
            },
            getActivePresence: function () {
                return activePresence;
            }
        };


        var getScenarioTag = function (scenario) {
            var utagObj;
            switch (scenario + '') {
                case 'Scenarios':
                    utagObj = {
                        "Page_Event": 21,
                        "Navigation_View": "ta",
                        "Page_Name": "Link : Search Successful",
                        "Page_Category": "Refill",
                        "Scenario_Name": "check ",
                        "Scenario_Step": "4"
                    };
                    break;
                default:
                    break;
            }
            ;
            return utagObj;
        };


        return webAnalytics;
    }]);
})();